export class CreateAsset {
    constructor(public equipmentTypeIri: string, public newAssetName: string) {
    }
}
